import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import {
  DialogProps,
  Divider,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import { AppContext } from '../../context/AppContext';
import {
  DATE_CREATED,
  MESSAGE_STATUS_ARRAY,
  ORDER_STATUS_ARRAY,
  PRODUCT_STATUS_ARRAY,
} from '../../constants/Constants';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  getProfile,
  getProfileState,
} from '../../redux_store/slices/GetUserProfileSlice';
import BakeasyCheckbox from '../common/BakeasyCheckbox';
import BakeasyDatePicker from '../common/BakeasyDatePicker';
import {
  BakeasySelectLabel,
  BakeasySelectLabelLanguage,
} from '../dropdowns/BakeasySelect';
import { BakeasyButton } from '../buttons/BakeasyButton';
import {
  BakeasyAutoCompleteCategory,
  BakeasyAutoCompleteMessagesTo,
  BakeasyAutoCompleteSubCategory,
} from '../dropdowns/BakeasyAutoComplete';
import {
  fetchSuppliers,
  suppliersState,
} from '../../redux_store/slices/GetsuppliersSlice';
import { productsState } from '../../redux_store/slices/productsSlice';
import * as TextField from '../textfields/BakeasyTextFields';
import { useSelector } from 'react-redux';
import dayjs, { Dayjs } from 'dayjs';
import { formatDateTime } from '../../utils/DateUtils';
import * as Dropdown from '../dropdowns/BakeasySelect';
import { BakeasyFilterHeaderLabel } from '../labels/BakeasyHeaderLabel';
import { createOrderState } from '../../redux_store/slices/createOrdersSlice';
import {
  fetchNewMessageCount,
  getNamesList,
  messagesState,
} from '../../redux_store/slices/messagesSlice';
import {
  BakeasySelectAutoCompleteMessageFrom,
  BakeasySelectAutoCompleteMessageTo,
} from '../dropdowns/BakeasySelectAutoComplete';
import { validateField } from '../../utils/ValidationUtils';
import { supplierState } from '../../redux_store/slices/supplierSlice';
import { GRAY_500 } from '../../constants/Colors';
import BakeasyTextField from '../textfields/BakeasyTextField';

export interface BakeasyConfirmDialogProps {
  dialog?: BakeasyConfirmDialogProp;
}

export interface BakeasyConfirmDialogProp {
  type?: string;
  open?: boolean;
  title?: string;
  message?: string | any;
  data?: any;
  onYesClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param?: any
  ) => void;
  onNoClick?: (event: React.MouseEvent<HTMLButtonElement>, param?: any) => void;
  onCancelClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param?: any
  ) => void;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': { padding: theme.spacing(2) },
  '& .MuiDialogActions-root': { padding: theme.spacing(1) },
}));

export default function BakeasyConfirmDialog(props: BakeasyConfirmDialogProps) {
  let myContext = React.useContext(AppContext);
  const dispatch = useAppDispatch();

  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('sm');
  const [text, setText] = useState<string>('');
  const [selectStores, setSelectStores] = useState<any>('');
  const [selectProduct, setSelectProduct] = useState<any>('');
  const [selectOrders, setSelectOrders] = useState<any>('');
  const [selectSubject, setSelectSubject] = useState<any>();
  const [selectStatus, setSelectStatus] = useState<any>();
  const [selectSupplier, setSelectSupplier] = useState<any>('');
  const [selectCategory, setSelectCategory] = useState<any>('');
  const [selectValues, setSelectValues] = useState<any>('');
  const [selectRecipeBuilder, setSelectRecipeBuilder] = useState<any>('');
  const [selectSendReceive, setSelectSendReceive] = useState<any>('');
  const [selectContent, setSelectContent] = useState<any>('');
  const [selectProducts, setSelectProducts] = useState<any>('');
  const [selectedLanguage, setSelectedLanguage] = React.useState('');
  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [isView, setIsView] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<any>('');
  const [selectedSubCategory, setSelectedSubCategory] = useState<any>('');
  const [selectedPriority, setSelectedPriority] = useState<any>('');
  const [checkedPriority, setCheckedPriority] = useState<any>('normal');
  const [createdFromDate, setCreatedFromDate] = useState<Dayjs | null>(null);
  const [createdToDate, setCreatedToDate] = useState<Dayjs | null>(null);
  const [selectedMessageStatus, setSelectedMessageStatus] = useState<any>('');
  const [selectedMessageFrom, setSelectedMessageFrom] = useState<any>();
  const [selectedMessageTo, setSelectedMessageTo] = useState<any>();
  const [invoicedFromDate, setInvoicedFromDate] = useState<Dayjs | null>(null);
  const [invoicedToDate, setInvoicedToDate] = useState<Dayjs | null>(null);
  const [dueFromDate, setDueFromDate] = useState<Dayjs | null>(null);
  const [dueToDate, setDueToDate] = useState<Dayjs | null>(null);
  const [invoiceFromDate, setInvoiceFromDate] = useState<Dayjs | null>(null);
  const [invoiceToDate, setInvoiceToDate] = useState<Dayjs | null>(null);
  const [shippedFromDate, setShippedFromDate] = useState<Dayjs | null>(null);
  const [shippedToDate, setShippedToDate] = useState<Dayjs | null>(null);
  const [orderedFromDate, setOrderedFromDate] = useState<Dayjs | null>(null);
  const [orderedToDate, setOrderedToDate] = useState<Dayjs | null>(null);
  const [selectedName, setSelectName] = useState<any>(undefined);
  const [error, setError] = useState<string>('');

  let _userProfile: any = useAppSelector(getProfileState);
  let _supplierState: any = useAppSelector(suppliersState);
  let _supplierData: any = useAppSelector(supplierState);
  let _productsState = useAppSelector(productsState);
  let _createOrdersState = useAppSelector(createOrderState);
  let _messagesState = useAppSelector(messagesState);
  const auth = useSelector((x: any) => x?.auth?.value);

  React.useEffect(() => {
    setSelectedLanguage(_userProfile?.value?.defaultLanguage);
  }, [_userProfile.value]);

  useEffect(() => {
    if (auth === undefined) {
      return;
    }

    dispatch(fetchNewMessageCount(''));
    if (_userProfile?.value === undefined) {
      dispatch(getProfile(''));
    } else {
      setSelectedLanguage(_userProfile?.value?.defaultLanguage);
    }

    if (_supplierState?.value?.data.length === 0) {
      dispatch(fetchSuppliers({ page: 1, limit: 10 }));
    }
  }, []);

  useEffect(() => {
    props?.dialog?.data?.createdFromDate &&
      setCreatedFromDate(dayjs(props?.dialog?.data?.createdFromDate));
    props?.dialog?.data?.createdToDate &&
      setCreatedToDate(dayjs(props?.dialog?.data?.createdToDate));
    props?.dialog?.data?.status &&
      setSelectedStatus(props?.dialog?.data?.status);
    props?.dialog?.data?.categoryName &&
      setSelectedCategory(props?.dialog?.data?.categoryName);
    props?.dialog?.data?.subCategoryName &&
      setSelectedSubCategory(props?.dialog?.data?.subCategoryName);
    props?.dialog?.data?.priority &&
      setSelectedPriority(props?.dialog?.data?.priority);
    props?.dialog?.data?.to && setSelectedMessageTo(props?.dialog?.data?.to);
    props?.dialog?.data?.from &&
      setSelectedMessageFrom(props?.dialog?.data?.from);
    props?.dialog?.data?.status &&
      setSelectedMessageStatus(props?.dialog?.data?.status);
    props?.dialog?.data?.shippedFromDate &&
      setShippedFromDate(dayjs(props?.dialog?.data?.shippedFromDate));
    props?.dialog?.data?.shippedToDate &&
      setShippedToDate(dayjs(props?.dialog?.data?.shippedToDate));
    props?.dialog?.data?.invoiceFromDate &&
      setInvoiceFromDate(dayjs(props?.dialog?.data?.invoiceFromDate));
    props?.dialog?.data?.invoiceToDate &&
      setInvoiceToDate(dayjs(props?.dialog?.data?.invoiceToDate));
    props?.dialog?.data?.orderedFromDate &&
      setOrderedFromDate(dayjs(props?.dialog?.data?.orderedFromDate));
    props?.dialog?.data?.orderedToDate &&
      setOrderedToDate(dayjs(props?.dialog?.data?.orderedToDate));
    props?.dialog?.data?.dueFromDate &&
      setDueFromDate(dayjs(props?.dialog?.data?.dueFromDate));
    props?.dialog?.data?.dueToDate &&
      setDueToDate(dayjs(props?.dialog?.data?.dueToDate));
  }, [props?.dialog?.data]);

  function handleOnClose(event?: any) {
    switch (props.dialog?.type) {
      case 'createOrder':
        if (props?.dialog?.onNoClick) {
          props?.dialog?.onNoClick(event);
        }
        break;
    }

    setError('');
    setText('');
    setSelectedStatus('');
    setSelectedCategory('');
    setSelectedSubCategory('');
    setSelectedPriority('');
    setSelectStatus('');
    setSelectedMessageStatus('');
    setSelectedMessageFrom('');
    setSelectedMessageTo('');
    setCreatedToDate(null);
    setCreatedFromDate(null);

    setSelectName('');
    setSelectSubject('');
    setSelectContent('');
    setCheckedPriority('normal');

    setShippedFromDate(null);
    setShippedToDate(null);
    setInvoiceToDate(null);
    setInvoiceFromDate(null);

    setOrderedFromDate(null);
    setOrderedToDate(null);
    setDueFromDate(null);
    setDueToDate(null);
    myContext.setConfirmDialog({ open: false });
  }

  function getLabelForYesButton(type: string | undefined): any {
    switch (type) {
      case 'product-filter':
      case 'storeOrdersfilter':
      case 'storeCreateOrderfilter':
      case 'StoreShippingFilter':
      case 'StoreInvoicesFilter':
      case 'message-filter':
      case 'invoice-filter':
      case 'product-order-filter':
      case 'orderHistoryfilter':
        return 'APPLY';
      case 'message-compose':
        return 'SEND';
      case 'language-Dialog':
        return 'SAVE';
      case 'forgotPassword':
      case 'Ok':
        return 'OK';
      case 'createOrder':
        return 'CONTINUE_WITH_CART';
      default:
        return 'YES';
    }
  }

  function handleMessageFilterApply(event: any) {
    let filter = {
      ...(createdFromDate && {
        createdFromDate: formatDateTime(createdFromDate?.toISOString()),
      }),
      ...(createdToDate && {
        createdToDate: formatDateTime(createdToDate?.toISOString()),
      }),
      ...(selectedPriority && { priority: selectedPriority }),
      ...(selectedMessageFrom && { from: selectedMessageFrom }),
      ...(selectedMessageTo && { to: selectedMessageTo }),
      ...(selectedMessageStatus && { status: selectedMessageStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose();
    }
  }

  function handleActivation(event: any, activation: boolean) {
    if (activation) {
      if (props?.dialog?.onYesClick) {
        props?.dialog?.onYesClick(event, activation);
        handleOnClose();
      }
    }
  }

  function handleOnYes(event: any) {
    switch (props.dialog?.type) {
      case 'language-Dialog':
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event, selectedLanguage);
          handleOnClose(event);
        }
        break;
      case 'product-filter':
        handleProductFilterApply(event);
        break;
      case 'orderHistoryfilter':
        handleStoreOrdersFilterApply(event);
        break;
      case 'product-order-filter':
        handleProductOrderFilterApply(event);
        break;
      // case 'delete':
      //   if (props?.dialog?.onYesClick) {
      //     props?.dialog?.onYesClick(event,);
      //     handleOnClose();
      //   }
      //   break;

      case 'delete':
        if (text === 'DELETE') {
          if (props?.dialog?.onYesClick) {
            props?.dialog?.onYesClick(event);
          }
          handleOnClose(event);
        } else {
          setError(t('PLEASE_TYPE_DELETE'));
        }
        break;

      // case 'delete':
      //   if (text === 'DELETE') {
      //     handleActivation(event, true);
      //   } else {
      //     setError(t('PLEASE_TYPE_DELETE'));
      //   }
      //   break;
      case 'message-filter':
        handleMessageFilterApply(event);
        break;

      case 'message-compose':
        if (!validateField(dispatch, 'PLEASE_SELECT_NAME', selectedName)) {
          return false;
        }
        if (!validateField(dispatch, 'PLEASE_ENTER_SUBJECT', selectSubject)) {
          return false;
        }
        if (
          !validateField(dispatch, 'PLEASE_ENTER_DESCRIPTION', selectContent)
        ) {
          return false;
        }
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event, {
            selectedName,
            selectSubject,
            selectContent,
            checkedPriority,
          });
          handleOnClose(event);
        }
        break;
      case 'StoreShippingFilter': {
        handleShippingFilterApply(event);
        break;
      }
      case 'invoice-filter':
        handleInvoiceFilterApply(event);
        break;
      case 'go-backToOrder':
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event);
          // handleOnClose();
        }
        break;
      case 'createOrder':
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event);
          // handleOnClose(event);
          myContext.setConfirmDialog({ open: false });
        }
        break;
      default:
        if (props?.dialog?.onYesClick) {
          props?.dialog?.onYesClick(event);
          handleOnClose(event);
        }
    }
  }

  function handleProductFilterApply(event: any) {
    let filter = {
      ...(selectedCategory && { categoryName: selectedCategory }),
      ...(selectedSubCategory && { subCategoryName: selectedSubCategory }),
      ...(selectedStatus && { status: selectedStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose(event);
    }
  }

  function handleStoreOrdersFilterApply(event: any) {
    let filter = {
      ...(orderedFromDate && {
        orderedFromDate: formatDateTime(orderedFromDate?.toISOString()),
      }),
      ...(orderedToDate && {
        orderedToDate: formatDateTime(orderedToDate?.toISOString()),
      }),
      ...(dueFromDate && {
        dueFromDate: formatDateTime(dueFromDate?.toISOString()),
      }),
      ...(dueToDate && { dueToDate: formatDateTime(dueToDate?.toISOString()) }),
      ...(selectedStatus && { status: selectedStatus }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose(event);
    }
  }

  function handleShippingFilterApply(event: any) {
    let filter = {
      ...(shippedFromDate && {
        shippedFromDate: formatDateTime(shippedFromDate?.toISOString()),
      }),
      ...(shippedToDate && {
        shippedToDate: formatDateTime(shippedToDate?.toISOString()),
      }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose(event);
    }
  }

  function handleInvoiceFilterApply(event: any) {
    let filter = {
      ...(invoiceFromDate && {
        invoiceFromDate: formatDateTime(invoiceFromDate?.toISOString()),
      }),
      ...(invoiceToDate && {
        invoiceToDate: formatDateTime(invoiceToDate?.toISOString()),
      }),
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose(event);
    }
  }

  function handleProductOrderFilterApply(event: any) {
    let filter = {
      ...(selectedCategory && { categoryName: selectedCategory }),
      ...(selectedSubCategory && { subCategoryName: selectedSubCategory }),
      //...(selectedStatus && { status: selectedStatus })
    };

    if (props?.dialog?.onYesClick) {
      props?.dialog?.onYesClick(event, filter);
      handleOnClose(event);
    }
  }

  function getLabelForNoButton(type: string | undefined): any {
    switch (type) {
      case 'product-filter':
      case 'storeOrdersfilter':
      case 'storeCreateOrderfilter':
      case 'StoreShippingFilter':
      case 'StoreInvoicesFilter':
      case 'message-filter':
      case 'invoice-filter':
      case 'orderHistoryfilter':
      case 'message-compose':
      case 'language-Dialog':
      case 'product-order-filter':
        return 'CANCEL';
      case 'createOrder':
        return 'CREATE_NEW_ORDER';
      default:
        return 'NO';
    }
  }

  function messageCompose() {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BakeasyAutoCompleteMessagesTo
            disabled={isView}
            value={selectedName}
            options={[
              {
                _id: _supplierData.value?._id,
                supplierName: _supplierData.value?.supplierName,
                supplierEntityId: _supplierData.value?.supplierEntityId,
              },
            ]}
            onChange={(newValue: any) => {
              // if (typeof newValue === 'string' && newValue?.length > 2) {
              //   dispatch(fetchSupplierDetails({ page: 1, limit: 5, search: newValue }));
              // }
              if (typeof newValue === 'object') {
                setSelectName(newValue);
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField.Subject
            value={selectSubject}
            placeHolder={t('ENTER_SUBJECT')}
            onChange={(event: any) => {
              setSelectSubject(event.target.value);
            }}
          />{' '}
        </Grid>
        <Grid item xs={12}>
          <TextField.Description
            value={selectContent}
            placeHolder={t('ENTER_DESCRIPTION')}
            maxLength={800}
            onChange={(event: any) => {
              setSelectContent(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <small style={{ color: GRAY_500 }}>
            {t('NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS')}
          </small>
        </Grid>
        <Grid item xs={12}>
          <BakeasyCheckbox
            label={t('SET_AS_HIGH_PRIORITY')}
            value={checkedPriority === 'urgent'}
            onClick={(event: any) => {
              if (event?.target?.checked) {
                setCheckedPriority('urgent');
              } else {
                setCheckedPriority('normal');
              }
            }}
          />
        </Grid>
      </Grid>
    );
  }

  function StoreShippingFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyFilterHeaderLabel message={t('SHIPPED_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={shippedFromDate}
            onChange={(value: any) => {
              setShippedFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={shippedToDate}
            onChange={(value: any) => {
              setShippedToDate(value);
            }}
          />
        </Grid>
      </>
    );
  }

  function StoreInvoicesFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2} sx={{ marginTop: 1 }}>
          <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
            {t('INVOICED_DATE')}
          </Typography>
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker label={t('FROM')} />
          <BakeasyDatePicker label={t('TO')} />
        </Grid>
      </>
    );
  }

  function storeCommonfilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2}>
          <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
            {t('CREATED_DATE')}
          </Typography>
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker label={t('FROM')} />
          <BakeasyDatePicker label={t('TO')} />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          sx={{ marginTop: 1 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <BakeasySelectLabel
                required={true}
                label={t('CATEGORY')}
                size="small"
                statusOptions={DATE_CREATED}
                placeholder={t('SELECT_CATEGORY')}
                fullWidth={true}
                value={selectStatus}
                onChange={(event) => setSelectStatus(event?.target?.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <BakeasySelectLabel
                required={true}
                label={t('SUB_CATEGORY')}
                placeholder={t('SELECT_SUBCATEGORY')}
                size="small"
                statusOptions={DATE_CREATED}
                fullWidth={true}
                value={selectStatus}
                onChange={(event) => setSelectStatus(event?.target?.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  function messageFilter() {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item display={'flex'} columnGap={2}>
            <BakeasyFilterHeaderLabel message={t('CREATED_DATE')} />
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasyDatePicker
                label={t('FROM')}
                value={createdFromDate}
                onChange={(value: any) => {
                  setCreatedFromDate(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasyDatePicker
                label={t('TO')}
                value={createdToDate}
                onChange={(value: any) => {
                  setCreatedToDate(value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <Dropdown.Priority
                value={selectedPriority}
                onChange={(event) => setSelectedPriority(event?.target?.value)}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <Dropdown.MessageStatus
                options={MESSAGE_STATUS_ARRAY}
                value={selectedMessageStatus}
                onChange={(event) =>
                  setSelectedMessageStatus(event?.target?.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasySelectAutoCompleteMessageFrom
                disabled={isView}
                value={selectedMessageFrom}
                options={_messagesState?.name}
                onChange={(newValue: any) => {
                  if (newValue === null) {
                    setSelectedMessageFrom(undefined);
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }

                  if (typeof newValue === 'string' && newValue?.length > 2) {
                    if (
                      _messagesState?.name?.find(
                        (item: any) => item?.name === newValue
                      )
                    ) {
                      setSelectedMessageFrom(newValue);
                    } else {
                      dispatch(
                        getNamesList({ page: 1, limit: 5, search: newValue })
                      );
                    }
                  }

                  if (typeof newValue === 'string' && newValue?.length === 0) {
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
              <BakeasySelectAutoCompleteMessageTo
                disabled={isView}
                value={selectedMessageTo}
                options={_messagesState?.name}
                onChange={(newValue: any) => {
                  if (newValue === null) {
                    setSelectedMessageTo(undefined);
                    dispatch(getNamesList({ page: 1, limit: 5 }));
                  }
                  if (typeof newValue === 'string' && newValue?.length > 2) {
                    if (
                      _messagesState?.name?.find(
                        (item: any) => item?.name === newValue
                      )
                    ) {
                      setSelectedMessageTo(newValue);
                    } else {
                      dispatch(
                        getNamesList({ page: 1, limit: 5, search: newValue })
                      );
                    }

                    if (
                      typeof newValue === 'string' &&
                      newValue?.length === 0
                    ) {
                      dispatch(getNamesList({ page: 1, limit: 5 }));
                    }
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  function invoiceFilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyFilterHeaderLabel message={t('INVOICE_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={invoiceFromDate}
            onChange={(value: any) => {
              setInvoiceFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={invoiceToDate}
            onChange={(value: any) => {
              setInvoiceToDate(value);
            }}
          />
        </Grid>
      </>
    );
  }

  function getContent(type: string | undefined, data: any): any {
    switch (type) {
      case 'storeCreateOrderfilter':
        return <>{storeCommonfilter()}</>;
      case 'product-filter':
        return <>{productFilter()}</>;
      // case 'storeOrdersfilter':
      //   return <>{storeOrdersfilter()}</>;
      case 'orderHistoryfilter':
        return <>{orderHistoryfilter()}</>;
      case 'StoreShippingFilter':
        return <>{StoreShippingFilter()}</>;
      case 'StoreInvoicesFilter':
        return <>{StoreInvoicesFilter()}</>;
      case 'message-filter':
        return <>{messageFilter()}</>;
      case 'message-compose':
        return <>{messageCompose()}</>;
      case 'invoice-filter':
        return <>{invoiceFilter()} </>;
      case 'language-Dialog':
        return <>{languageDialog()}</>;
      case 'product-order-filter':
        return <>{productOrdersfilter()}</>;
      case 'delete':
        return (
          <BakeasyTextField
            label={t('PLEASE_TYPE_DELETE')}
            placeHolder={t('PLEASE_TYPE_DELETE')}
            type={''}
            fullWidth={true}
            name={''}
            value={text}
            maxLength={10}
            onChange={function (
              event: React.ChangeEvent<HTMLInputElement>
            ): void {
              setText(event?.target.value);
            }}
          />
        );
      default:
        return <></>;
    }
  }

  function languageDialog() {
    return (
      <Grid item>
        <BakeasySelectLabelLanguage
          value={selectedLanguage}
          onChange={(e: any) => {
            setSelectedLanguage(e.target.value);
          }}
        />
      </Grid>
    );
  }

  function productFilter() {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
          <BakeasyAutoCompleteCategory
            value={selectedCategory}
            options={_productsState?.value?.categories}
            onChange={(newValue: any) => {
              if (typeof newValue === 'string' && newValue?.length > 0) {
                if (_productsState?.value?.categories?.includes(newValue)) {
                  setSelectedCategory(newValue);
                }
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
          <BakeasyAutoCompleteSubCategory
            value={selectedSubCategory}
            options={_productsState?.value?.subCategories}
            onChange={(newValue: any) => {
              if (typeof newValue === 'string' && newValue?.length > 0) {
                if (_productsState?.value?.subCategories?.includes(newValue)) {
                  setSelectedSubCategory(newValue);
                }
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
          <Dropdown.Status
            options={PRODUCT_STATUS_ARRAY}
            value={selectedStatus}
            onChange={(event: any) => setSelectedStatus(event?.target?.value)}
          />
        </Grid>
      </Grid>
    );
  }

  function productOrdersfilter() {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <BakeasyAutoCompleteCategory
              value={selectedCategory}
              options={_createOrdersState?.value?.categories}
              onChange={(newValue: any) => {
                if (typeof newValue === 'string' && newValue?.length > 0) {
                  if (
                    _createOrdersState?.value?.categories?.includes(newValue)
                  ) {
                    setSelectedCategory(newValue);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <BakeasyAutoCompleteSubCategory
              value={selectedSubCategory}
              options={_createOrdersState?.value?.subCategories}
              onChange={(newValue: any) => {
                if (typeof newValue === 'string' && newValue?.length > 0) {
                  if (
                    _createOrdersState?.value?.subCategories?.includes(newValue)
                  ) {
                    setSelectedSubCategory(newValue);
                  }
                }
              }}
            />
          </Grid>
        </Grid>
      </>
    );
  }

  function orderHistoryfilter() {
    return (
      <>
        <Grid item display={'flex'} columnGap={2} sx={{ marginTop: 0 }}>
          <BakeasyFilterHeaderLabel message={t('ORDER_DATE')} />
        </Grid>
        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={orderedFromDate}
            onChange={(value: any) => {
              setOrderedFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={orderedToDate}
            onChange={(value: any) => {
              setOrderedToDate(value);
            }}
          />
        </Grid>

        <Grid item display={'flex'} columnGap={2} sx={{ marginTop: 1 }}>
          <BakeasyFilterHeaderLabel message={t('DUE_DATE')} />
        </Grid>

        <Grid item display={'flex'} columnGap={2}>
          <BakeasyDatePicker
            label={t('FROM')}
            value={dueFromDate}
            onChange={(value: any) => {
              setDueFromDate(value);
            }}
          />
          <BakeasyDatePicker
            label={t('TO')}
            value={dueToDate}
            onChange={(value: any) => {
              setDueToDate(value);
            }}
          />
        </Grid>

        <Grid container spacing={2} mt={0}>
          <Grid item xs={12} sm={6}>
            <Dropdown.Status
              value={selectedStatus}
              options={ORDER_STATUS_ARRAY}
              onChange={(event: any) => setSelectedStatus(event?.target?.value)}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
              <BakeasyDatePicker
                label={t('TO')}
                value={invoicedToDate}
                onChange={(value: any) => {
                  setInvoicedToDate(value);
                }}
              />
            </Grid> */}
        </Grid>
      </>
    );
  }

  return (
    <React.Fragment>
      <BootstrapDialog
        open={props?.dialog?.open ? props?.dialog?.open : false}
        fullWidth={true}
        maxWidth={maxWidth}
      >
        <DialogTitle
          sx={{ margin: 0, padding: 2 }}
          style={{ fontWeight: 600, fontSize: '1.2rem' }}
          minWidth={200}
        >
          <Grid container sx={{ flexDirection: 'row' }}>
            {t(props?.dialog?.title as string)}
          </Grid>
        </DialogTitle>

        <IconButton
          onClick={(event: any) => {
            props?.dialog?.onCancelClick
              ? props?.dialog?.onCancelClick(event)
              : handleOnClose();
          }}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <Divider />
        <DialogContent sx={{ margin: 0 }}>
          {props?.dialog?.message && props?.dialog?.message}
          {props?.dialog?.message && <Grid sx={{ margin: 1 }} />}
          {props?.dialog?.type &&
            getContent(props?.dialog?.type, props?.dialog?.data)}
          {error && (
            <Grid mt={2} px={1} sx={{ color: 'red' }}>
              {error ?? error}
            </Grid>
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ margin: 0, columnGap: 1 }}>
          {props?.dialog?.onNoClick && (
            <BakeasyButton
              fullWidth={false}
              label={t(getLabelForNoButton(props?.dialog?.type))}
              variant="outlined"
              onClick={handleOnClose}
            />
          )}

          {props?.dialog?.onYesClick && (
            <BakeasyButton
              fullWidth={false}
              label={t(getLabelForYesButton(props?.dialog?.type))}
              onClick={handleOnYes}
            />
          )}
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
